import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setClippingProductId, setCouponDescriptionModalVisible, setSelectedCoupon } from "redux/actions";
import LoadingImage from "../../assets/icons/load.gif";
import "./coupon-card-theme2.scss";
import { useClipCouponDetails } from 'hooks/useClipCouponHandlers';
import { ClipImage, UnClipImage } from 'config/svgImages';

const CouponCardTheme2 = ({ coupon }) => {
  const dispatch = useDispatch();

  const isUserLoggedIn = useSelector(({ user }) => user.isUserLoggedIn);
  const {clippingProductId} = useSelector(({ cartCoupon }) => cartCoupon);

  const { couponCartList, addCouponToCartListLoading, removeCouponToCartListLoading, couponDescriptionModalVisible } = useSelector(
    ({ cartCoupon }) => cartCoupon
  );
  const addedCoupon = couponCartList?.find(c => c.offer_id === coupon.offer_id);
  const showLoader =
  clippingProductId &&
    clippingProductId === coupon.offer_id &&
    !couponDescriptionModalVisible &&
    (addCouponToCartListLoading || removeCouponToCartListLoading)

  const { handleAddToCart, handleRemoveCouponToCart } = useClipCouponDetails(coupon);

  function clipCoupon() {
    dispatch(setClippingProductId(coupon.offer_id))
    handleAddToCart()
  }

  function unclipCoupon() {
    dispatch(setClippingProductId(null))
    handleRemoveCouponToCart(coupon.offer_id)
  }

  return (
    <>
      <div className="coupon-card-theme2" key={coupon.offer_id}>
        <div className="coupon-card-ribbons">
          {coupon.plu_code === "100.00%" || coupon.plu_code === "100%" ? (
            <div className="coupon-design-ribbon">
              <div className="coupon-design">
                <p>
                  <span>Free*</span>
                </p>
              </div>
            </div>
          ) : (
            <div className="coupon-design-ribbon">
              <div className="coupon-design">
                <p>
                  <span>{coupon.plu_code}</span>
                </p>
              </div>
            </div>
          )}

          {coupon.coupon_limit ? (
            <div className="coupon-used-time-ribbon">
              {coupon.coupon_limit === "1" ? (
                ""
              ) : (
                <div className="coupon-used-time">
                  <p>
                    <span>{coupon.coupon_limit + "X"}</span>
                  </p>
                </div>
              )}
            </div>
          ) : (
            ""
          )}
        </div>

        <div className="product-card-image">
          <div className="modal__btn">
            <a
              href={() => false}
              onClick={() => {
                dispatch(setSelectedCoupon(coupon))
                dispatch(setCouponDescriptionModalVisible(!couponDescriptionModalVisible))
              }}>
              <img src={coupon.image_path} alt="ProductImage" />
            </a>
          </div>
        </div>

        <div className="product-card-details">
          <div className="product-card-main-detail">
            {coupon?.title ? <h3 className="coupon-title">{coupon?.title}</h3> : null}
            <h3>{`Save ${coupon.plu_code === "100.00%" || coupon.plu_code === "100%"
              ? coupon.plu_code + "*"
              : coupon.plu_code
              }`}</h3>
            <p className="coupon-details"> {coupon?.details}</p>
          </div>

          <div className="button-group-alignment">
            <div className="add-to-cart">
              {isUserLoggedIn ? (
                <>
                  {showLoader ? (
                    <div className="load-icon">
                      <img src={LoadingImage} alt="Loading..." />
                    </div>
                  ) : (
                    <>
                      {addedCoupon ? (
                        <button
                          className="cart-remove"
                          title="Click to unclip"
                          disabled={showLoader}
                          onClick={unclipCoupon}>
                          <UnClipImage />
                          <span>Unclip</span>
                        </button>
                      ) : (
                        <button
                          className="cart-add"
                          onClick={clipCoupon}
                          disabled={addedCoupon || showLoader}
                          title="Click to clip">
                          <ClipImage />
                          <span>Clip</span>
                        </button>
                      )}
                    </>
                  )}
                </>
              ) : (
                <button
                  className="cart-add"
                  onClick={clipCoupon}
                  disabled={addedCoupon || showLoader}
                  title="Click to clip">
                  <ClipImage />
                  <span>Clip</span>
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CouponCardTheme2;
